// @ts-check

if (!process.env.DEBUG) {
  window.console.log = function () {}
  window.console.debug = function () {}
  window.console.trace = function () {}
}
